/**
 * Type definition for application-wide design tokens.
 * Ensuring a shared structure between light and dark themes.
 */
export type ThemeTokens = {
  '--cb-bg-primary': string;
  '--cb-bg-surface': string;
  '--cb-bg-elevated': string;
  '--cb-border': string;
  '--cb-accent': string;
  '--cb-accent-light': string;
  '--cb-gold': string;
  '--cb-text-primary': string;
  '--cb-text-secondary': string;
  '--cb-text-muted': string;
  '--cb-success': string;
  '--cb-warning': string;
  '--cb-danger': string;
  '--cb-neutral': string;
  '--cb-card-shadow': string;
  '--cb-sidebar-bg': string;
  '--cb-sidebar-hover': string;
  '--cb-sidebar-hover-text': string;
  '--cb-overlay-bg': string;
  '--cb-accent-subtle': string;
};

/**
 * Tokens applied when the dark color scheme is active.
 */
export const darkTokens = {
  '--cb-bg-primary': '#0A1628',
  '--cb-bg-surface': '#0D2040',
  '--cb-bg-elevated': '#111827',
  '--cb-border': '#1E3A5F',
  '--cb-accent': '#1E6FFF',
  '--cb-accent-light': '#4D8FFF',
  '--cb-gold': '#C9A84C',
  '--cb-text-primary': '#FFFFFF',
  '--cb-text-secondary': '#9CA3AF',
  '--cb-text-muted': '#6B7280',
  '--cb-success': '#10B981',
  '--cb-warning': '#F59E0B',
  '--cb-danger': '#EF4444',
  '--cb-neutral': '#6B7280',
  '--cb-card-shadow': 'rgba(0,0,0,0.4)',
  '--cb-sidebar-bg': '#0D2040',
  '--cb-sidebar-hover': '#1e3a5f',
  '--cb-sidebar-hover-text': '#ffffff',
  '--cb-overlay-bg': 'rgba(0, 0, 0, 0.7)',
  '--cb-accent-subtle': 'rgba(30, 111, 255, 0.125)',
} as const satisfies ThemeTokens;

/**
 * Tokens applied when the light color scheme is active.
 */
export const lightTokens = {
  '--cb-bg-primary': '#F8FAFF',
  '--cb-bg-surface': '#FFFFFF',
  '--cb-bg-elevated': '#F1F5F9',
  '--cb-border': '#E2E8F0',
  '--cb-accent': '#1E6FFF',
  '--cb-accent-light': '#4D8FFF',
  '--cb-gold': '#9A7A2C',
  '--cb-text-primary': '#0A1628',
  '--cb-text-secondary': '#4B5563',
  '--cb-text-muted': '#9CA3AF',
  '--cb-success': '#10B981',
  '--cb-warning': '#F59E0B',
  '--cb-danger': '#EF4444',
  '--cb-neutral': '#6B7280',
  '--cb-card-shadow': 'rgba(0,0,0,0.08)',
  '--cb-sidebar-bg': '#EEF2F9',
  '--cb-sidebar-hover': 'rgba(30, 111, 255, 0.08)',
  '--cb-sidebar-hover-text': '#0A1628',
  '--cb-overlay-bg': 'rgba(0, 0, 0, 0.5)',
  '--cb-accent-subtle': 'rgba(30, 111, 255, 0.08)',
} as const satisfies ThemeTokens;
